<script setup lang="ts">
import BaseLayout from '@/components/base/BaseLayout.vue'
import type { FilterOption } from '@/types/filter.types'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MyClassFilterSection from '../components/MyClassFilterSection.vue'
import MyClassListSection from '../components/MyClassListSection.vue'

const router = useRouter()
const route = useRoute()

// 선택된 필터 상태 관리
const selectedCategory = ref<FilterOption>({
  idx: 0,
  name: '구매한 강좌',
  data: 'purchased',
})

// URL에서 카테고리 가져오기
onMounted(() => {
  const categoryFromQuery = route.query.category as string
  if (categoryFromQuery === 'liked') {
    selectedCategory.value = {
      idx: 1,
      name: '찜한 강좌',
      data: 'liked',
    }
  }
})

// 카테고리 변경 핸들러
const handleCategoryChange = (category: FilterOption) => {
  selectedCategory.value = category

  // URL 쿼리 파라미터 업데이트
  router.replace({
    query: {
      ...route.query,
      category: category.data,
    },
  })
}
</script>

<template>
  <BaseLayout>
    <div class="my-class-view">
      <MyClassFilterSection @change="handleCategoryChange" :initialCategory="selectedCategory" />
      <MyClassListSection :selectedCategory="selectedCategory" />
    </div>
  </BaseLayout>
</template>

<style scoped>
.my-class-view {
  padding: 0px;
}

@media (max-width: 1365px) {
  .my-class-view {
    padding: 0px;
  }
}
</style>
